import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import AverageStopsPerRouteCardConfiguration from "@app/types/dashboard/cards/averageStopsPerRoute/AverageStopsPerRouteCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

import AverageStopsPerRouteCardData from "./AverageStopsPerRouteCardData";

export const fetchAverageStopsPerRouteCardData = createAction(
  "@dashboard/fetchAverageStopsPerRouteCardData"
)<{
  callback: (data: AverageStopsPerRouteCardData) => void;
  configuration: AverageStopsPerRouteCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showAverageStopsPerRouteDrillDown = createAsyncAction(
  "@dashboard/showAverageStopsPerRouteCardDrillDownModal/request",
  "@dashboard/showAverageStopsPerRouteCardDrillDownModal/success",
  "@dashboard/showAverageStopsPerRouteCardDrillDownModal/failure"
)<
  {
    configuration: AverageStopsPerRouteCardConfiguration;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideAverageStopsPerRouteDrillDown = createAction(
  "@dashboard/hideAverageStopsPerRouteCardDrillDownModal"
)<void>();

export const fetchAverageStopsPerRouteCardDrillDownData = createAsyncAction(
  "@dashboard/fetchAverageStopsPerRouteCardDrillDownData/request",
  "@dashboard/fetchAverageStopsPerRouteCardDrillDownData/success",
  "@dashboard/fetchAverageStopsPerRouteCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<AnyEntity>,
  {
    totalFilteredRoutes: number;
    totalRoutes: number;
  },
  unknown
>();

export const applyAverageStopsPerRouteDrillDownListViewSettings = createAction(
  "@dashboard/applyAverageStopsPerRouteDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export type AverageStopsPerRouteCardActions = ActionType<
  | typeof applyAverageStopsPerRouteDrillDownListViewSettings
  | typeof fetchAverageStopsPerRouteCardData
  | typeof fetchAverageStopsPerRouteCardDrillDownData
  | typeof hideAverageStopsPerRouteDrillDown
  | typeof showAverageStopsPerRouteDrillDown
>;
